import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cs-header-subtitle',
  templateUrl: 'cs-header-subtitle.html',
  host: { 'class': 'header-subtitle' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsHeaderSubtitle {
  // Component uses ng-content to allow flexible content
}
